import React from 'react'
import styled from '@emotion/styled'
import { P1 } from 'src/components/Typography'
import { useTheme } from 'src/shared/themeContext'

type NoteProps = {
  children: React.ReactNode
} & React.HTMLAttributes<HTMLDivElement>

const Note = ({ children, ...props }: NoteProps) => {
  const { brand, spacing } = useTheme()

  const StyledNote = styled.div`
    position: relative;
    width: 100%;
    background: ${brand.primary.background};
    padding: ${spacing.sm};
    border-radius: 5px;
  `
  const StyledContainer = styled(P1)`
    position: relative;

    ::before {
      content: '';
      height: 100%;
      width: ${spacing.xs};
      background: ${brand.primary.emphasis};
      border-radius: 5px;
      position: absolute;
    }
  `
  const TextContainer = styled.div`
    margin-left: ${spacing.md};
  `
  return (
    <StyledNote {...props}>
      <StyledContainer>
        <TextContainer>{children}</TextContainer>
      </StyledContainer>
    </StyledNote>
  )
}

export default Note
